import React, { Fragment } from "react";
import Sidebar from "../../common/Sidebar2nd/Sidebar";
import { NavLink } from "react-router-dom";
import { TableContent } from "./data";
import "./CreatorActivity1.css";
const CreatorActivity1 = () => {
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          {/* <!-- Creator-1 --> */}
          <div className="col-11 TableMax-width mx-auto my-5 py-md-5 marginTop10">
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex justify-content-between align-items-center mt-md-0 mt-4">
                  <h2 className="TableHeading mb-0">My Drops</h2>
                  <NavLink
                    to={`/creator/UploadMedia`}
                    className="CreateBtn DetailedBtn"
                  >
                    Upload Media
                    <i className="fa fa-upload ms-2" aria-hidden="true"></i>
                  </NavLink>
                </div>
              </div>
              <div className="col-md-12 mt-5">
                {/* <!-- Tabs --> */}
                <div className="CreatorWrapper">
                  <ul className="mb-3 Creator_Link">
                    <ul
                      className="left_Creator nav nav-pills"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <span className="UploadedContent">
                          Uploaded Contents
                        </span>
                      </li>
                    </ul>
                    <ul className="Right_Creator">
                      <li>
                        <span>7d</span>
                      </li>
                      <li>
                        <span className="me-3">30d</span>
                      </li>
                      <li>
                        <button className="Right_CreatorBtn btn">
                          Primary
                        </button>
                      </li>
                    </ul>
                  </ul>
                  <div
                    className="tab-content StashTabs_Content"
                    id="pills-tabContent"
                  >
                    {/* <!-- 1 Tabs --> */}
                    <div
                      className="tab-pane fade show active"
                      id="pills-sale1"
                      role="tabpanel"
                      aria-labelledby="pills-sale1-tab"
                    >
                      {/* <!-- Table Header --> */}
                      <div className="CreatorTH">
                        <div className="row row-cols-7 mx-0">
                          <div className="col-3">
                            <span className="">Rank</span>
                          </div>
                          <div className="col">
                            <span>Genre</span>
                          </div>
                          <div className="col">
                            <span>Unique Collectors</span>
                          </div>
                          <div className="col">
                            <span>Unique Collectors</span>
                          </div>
                          <div className="col">
                            <span>Primary Sales</span>
                          </div>
                          <div className="col">
                            <span>Secondary Sales</span>
                          </div>
                          <div className="col-1">
                            <span>Options</span>
                          </div>
                        </div>
                      </div>
                      {/* <!-- Table Content --> */}
                      {TableContent.map((item) => {
                        const SaleImg = require(`../../assets/${item.RankImg}`);
                        return (
                          <div className="CreatorTC">
                            <div className="row row-cols-7 mx-0">
                              <div className="col-3">
                                <span className="img-txt me-3">
                                  {item.RankNo}
                                </span>

                                <img
                                  src={SaleImg}
                                  className="img-fluid me-3"
                                  alt=""
                                />
                                <span className="img-txt">{item.RankName}</span>
                              </div>
                              <div className="col">
                                <span>{item.Genre}</span>
                              </div>
                              <div className="col">
                                <span>{item.Unique}</span>
                              </div>
                              <div className="col">
                                <span>{item.UniqueCollector}</span>
                              </div>
                              <div className="col">
                                <span>{item.PrimarySale}</span>
                              </div>
                              <div className="col">
                                <span>{item.SecondarySale}</span>
                              </div>
                              <div className="col-1">
                                <span className="me-4">
                                  <NavLink to="">
                                    <i
                                      className="fa fa-trash-o"
                                      aria-hidden="true"
                                    ></i>
                                  </NavLink>
                                </span>
                                <span>
                                  <NavLink to="">
                                    <i
                                      className="fa fa-pencil"
                                      aria-hidden="true"
                                    ></i>
                                  </NavLink>
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {/* <!-- Table Footer --> */}
                      <div className="CreatorTF">
                        <div className="row mx-0 justify-content-between">
                          <div className="col-3">
                            <button className="btn Btn_Previous">
                              Previous
                            </button>
                          </div>
                          <div className="col-3 d-flex justify-content-center">
                            <span className="Page_txt">Page 1 of 10</span>
                          </div>
                          <div className="col-3 d-flex justify-content-end">
                            <button className="btn Btn_Previous">Next</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--ENd Tabs --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CreatorActivity1;
